export default {
  template: `
  <div class="customer-bulk-delete-component">
    <div class="panel panel-default">
      <div class="panel-heading">Unblock customers 
        <p class="m-t-sm">To use for customers that had been flag as fraudulent but have shown proof of reservation and should have their account unblocked</p>
      </div>
      <div class="panel-body">
        <div class="col-md-6">
          <textarea class="form-control"
                    data-ng-model="$ctrl.emails"></textarea>
          <p data-ng-if="$ctrl.invalidEmails.length > 0">{{$ctrl.invalidEmails}}</p>
        </div>
        <div>
          <div class="col-md-6">
            <button class="btn btn-dark" 
                    data-ng-click="$ctrl.unblock()" 
                    data-ng-disabled="!($ctrl.emails && $ctrl.emails.length > 0)">Unblock customers</button>  
          </div>
        </div>
      </div>
    </div>
  </div>
  `,
  controller: class {
    constructor($window, unblockCustomersService, NotificationService) {
      this.unblockCustomersService = unblockCustomersService;
      this.notificationService = NotificationService;
      this.emails = '';
      this.window = $window;
      this.invalidEmails = '';
    }

    unblock() {
      this.invalidEmails = '';

      if (!this.window.confirm('Are you sure you want to unblock these customers?')) {
        return;
      }

      const trimEmptySpaces = email => email.trim();
      const removeEmptyStrings = email => email.length > 0;
      this.unblockCustomersService
        .unblock(
          this.emails
            .split(',')
            .map(trimEmptySpaces)
            .filter(removeEmptyStrings),
        )
        .then(() => this.notificationService.success('Customers were successfully unblocked'))
        .catch((error) => {
          this.notificationService.error('There was an error performing the operation');
          this.invalidEmails = error.data && error.data.errors[0].message;
        });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/customers/unblock-customers/unblock-customers.component.js